"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEditorTheme = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const mui_rte_1 = __importDefault(require("mui-rte"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const styles_1 = require("@material-ui/core/styles");
const formik_1 = require("formik");
const draft_js_1 = require("draft-js");
const lodash_1 = require("lodash");
const utils_1 = require("../utils");
exports.defaultEditorTheme = styles_1.createMuiTheme();
Object.assign(exports.defaultEditorTheme, {
    overrides: {
        MUIRichTextEditor: {
            root: {
                height: '100%',
            },
            container: {
                display: 'flex',
                flexDirection: 'column-reverse',
                height: '100%',
                '& div:nth-child(2)': {
                    width: '100%',
                    height: 'calc(100% - 16px)',
                },
            },
            editor: {
                paddingLeft: 10,
                overflowY: 'auto',
                height: '100%',
            },
            toolbar: {
                backgroundColor: 'rgba(17,15,36,0.2)',
                marginBottom: 8,
                borderBottomRightRadius: '4px',
                borderBottomLeftRadius: '4px',
            },
            placeHolder: {
                paddingLeft: 10,
                width: 'inherit',
                position: 'absolute',
                top: 0,
            },
        },
    },
});
const useStyles = styles_1.makeStyles((theme) => ({
    editorContainer: {
        flex: 1,
        position: 'relative',
        maxHeight: '250px',
        msOverflowY: 'scroll',
    },
    icon: {
        cursor: 'pointer',
        position: 'absolute',
        right: 0,
        bottom: 0,
        opacity: 0.5,
    },
    readOnlyText: {
        '& p': {
            fontSize: '1rem',
            lineHeight: '16px',
        },
    },
    inputLabel: {
        color: theme.palette.primary.main,
        pointerEvents: 'none',
        fontSize: '14px',
        marginLeft: '8px',
        fontWeight: 400,
        position: 'absolute',
    },
}));
const RenderRichTextField = (props) => {
    const { field: { value, name }, form: { touched, errors, setFieldValue, setFieldTouched, submitCount, initialValues }, fieldLabel, placeholder, controls, defaultValue, allwaysOpen, onClick = () => undefined, ...otherProps } = props;
    const classes = useStyles();
    const error = formik_1.getIn(errors, name);
    const touch = formik_1.getIn(touched, name);
    const [editMode, switchEditMode] = react_1.useState(allwaysOpen);
    const [focus, setFocus] = react_1.useState(false);
    //const initialValue = useRef(value || defaultValue);
    const [textState, setTextState] = react_1.useState();
    const [initState, setInitState] = react_1.useState();
    const displayErrors = (touch || submitCount > 0) && !!error;
    react_1.useEffect(() => {
        setInitState(value || defaultValue);
    }, [value, defaultValue]);
    react_1.useEffect(() => {
        //initialValue.current = initialValues[name];
        setInitState(initialValues[name]);
    }, [initialValues[name]]);
    react_1.useEffect(() => {
        if (!editMode) {
            //initialValue.current = value;
            setInitState(value);
        }
        else {
            setFieldTouched(name, true);
            onClick();
        }
    }, [editMode]);
    const debouncedSetFieldValue = lodash_1.debounce((value) => setFieldValue(name, value), 0);
    const onValueChange = (state) => {
        setTextState(state);
    };
    const onEditorBlur = () => {
        if (!allwaysOpen) {
            switchEditMode(false);
        }
        //save the last textState value to the form (saveFieldValue) when onBlur (leave) the input
        if (textState !== undefined) {
            debouncedSetFieldValue(JSON.stringify(draft_js_1.convertToRaw(textState.getCurrentContent())));
        }
        setFieldTouched(name, true);
        onClick();
        setFocus(false);
    };
    const onEditorFocus = () => {
        switchEditMode(true);
        setFocus(true);
    };
    return (react_1.default.createElement(Box_1.default, { onClick: () => switchEditMode(true), className: classes.editorContainer },
        fieldLabel &&
            (focus || utils_1.Utils.richTextContentToPlainText(value) !== utils_1.Utils.richTextContentToPlainText(defaultValue)) && (react_1.default.createElement(Typography_1.default, { variant: "subtitle2", className: classes.inputLabel }, fieldLabel)),
        react_1.default.createElement(styles_1.MuiThemeProvider, { theme: exports.defaultEditorTheme },
            react_1.default.createElement(mui_rte_1.default, Object.assign({ error: touch && !!error, label: placeholder, defaultValue: /* initialValue.current */ initState, controls: editMode ? controls : [], onChange: (state) => onValueChange(state), onBlur: () => onEditorBlur(), onFocus: () => onEditorFocus(), readOnly: !editMode, inlineToolbar: false }, otherProps))),
        displayErrors && (react_1.default.createElement(Box_1.default, { mt: -1 },
            react_1.default.createElement(Typography_1.default, Object.assign({ variant: "body2", component: "p", color: "error" }, otherProps), error)))));
};
RenderRichTextField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    fieldLabel: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    controls: prop_types_1.default.array,
    defaultValue: prop_types_1.default.any,
    allwaysOpen: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
};
RenderRichTextField.defaultProps = {
    fieldLabel: '',
    placeholder: '',
    defaultValue: JSON.stringify(draft_js_1.convertToRaw(draft_js_1.EditorState.createEmpty().getCurrentContent())),
    allwaysOpen: false,
};
exports.default = RenderRichTextField;
